import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { Admin } from './Admin.tsx'
import { AIGeneratePage } from './AIGeneratePage.tsx'
import App from './App.tsx'
import { Profile } from './Profile.tsx'
import { PublicTracks } from './PublicTracks.tsx'
import { ResetPassword } from './ResetPassword.tsx'
import { Router } from './Router.tsx'
import { TrackPage } from './TrackPage.tsx'
import { TutorialList } from './TutorialList.tsx'
import { TutorialPage } from './TutorialPage.tsx'

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://0dea075fe5eb35773eef962257e88ce9@o4510343187464192.ingest.us.sentry.io/4510343189037056',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    attachStacktrace: true,
    sendDefaultPii: true,
  })
}

createRoot(document.getElementById('root')!).render(
  <Router
    routes={[
      { path: '/', component: PublicTracks, title: 'loopmaster - Live Audio Programming' },
      { path: '/editor', component: App, title: 'loopmaster - Live Audio Programming' },
      { path: '/generate', component: AIGeneratePage, title: 'AI Generate - loopmaster' },
      { path: '/reset-password', component: ResetPassword, title: 'Reset Password - loopmaster' },
      { path: '/profile/:userId', component: Profile, title: 'Profile - loopmaster' },
      { path: '/loop/:trackId', component: TrackPage, title: 'Loop - loopmaster' },
      { path: '/admin', component: Admin, title: 'Admin - loopmaster' },
      { path: '/tutorials', component: TutorialList, title: 'Tutorials - loopmaster' },
      { path: '/tutorials/:id', component: TutorialPage, title: 'Tutorial - loopmaster' },
      { path: '/tutorial', component: () => <TutorialPage id="getting-started" />, title: 'Tutorial - loopmaster' },
    ]}
  />,
)
